import { render, staticRenderFns } from "./DashboardGestaoHeader.vue?vue&type=template&id=6c23f3bc&scoped=true"
import script from "./DashboardGestaoHeader.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoHeader.vue?vue&type=style&index=0&id=6c23f3bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23f3bc",
  null
  
)

export default component.exports